import * as React from 'react';
import { FileType, Logging } from '@vcd-ecm-ui/Common';
import { VtxIcon, VtxModal } from '@vertexinc/vtx-ui-react-component-library';
import AdditionalDocumentViewerProps from './AdditionalDocumentViewerProps.interface';
import '../additional-document-viewer.scss';
import DocumentViewer from '../DocumentViewer/DocumentViewer';

const customStyles = {
  padding: '0px',
  margin: '0px',
  border: '0px solid black',
  borderRadius: '0px',
  backgroundColor: 'unset',
};

const maskStyle = {
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
};

const style = {
  maxWidth: '100%',
  maxHeight: '100%',
  minHeight: '100%',
  padding: '0px',
  margin: '0px',
};

const AdditionalDocumentViewer = ({
  isOpen,
  setIsOpen,
  imageDocument,
}: AdditionalDocumentViewerProps): JSX.Element => {
  const [isPortrait, setIsPortrait] = React.useState(true);
  // Close the Side By Additional Document Viewer
  const onClose = (): void => {
    Logging.Info('Additional Document Viewer: Close');
    setIsOpen(false);
  };

  if (!imageDocument) {
    return (<></>);
  }

  // Disable Rotation on PDF Documents
  const canRotate = imageDocument.contentType !== FileType.Pdf;

  return (
    <VtxModal
      visible={isOpen}
      onCancel={(): void => onClose()}
      bodyStyle={customStyles}
      maskStyle={maskStyle}
      style={style}
      width={isPortrait ? '50%' : '90%'}
      footer={null}
      closable={false}
      destroyOnClose
    >
      <div className="sbsAdditionalDocumentViewerContainer">
        <div className="sbsAdditionalDocumentHeading">
          <p>{imageDocument.name}</p>
          <VtxIcon type="close-circle" color="white" fontSize={32} onClick={(): void => onClose()} />
        </div>
        <div className="sbsAdditionalDocumentContent">
          <DocumentViewer
            idPrefix="ad"
            canRotate={canRotate}
            setIsPortrait={setIsPortrait}
            imageDocument={imageDocument}
          />
        </div>
      </div>
    </VtxModal>
  );
};

export default AdditionalDocumentViewer;
